import View from 'view/view'
import Router from 'service/router'

import template from 'component/header/template/conversations.tmpl'
import ConversationListView from 'component/header/view/conversation_list'

import Counter from 'component/counter/model/counter'
import CounterView from 'component/counter/counter'
import CounterBadgeView from 'component/counter/badge'

import alertCounter from 'shared/model/alert_counter'
import experiment from 'service/experiment'

const ConversationsView = View.extend({
    template,

    initialize() {
        const getMessageAlertCount = () =>
            alertCounter.get('unreadMessageCount') + alertCounter.get('pendingContactRequestCount')

        const listenToChanges = ['change:unreadMessageCount', ...['change:pendingContactRequestCount']]

        this.counter = new Counter({
            maxCount: 99,
            count: getMessageAlertCount(),
        })

        this.listenTo(alertCounter, listenToChanges.join(' '), function() {
            this.counter.set({ count: getMessageAlertCount() })
        })

        this.listenTo(this.collection, 'request sync', this.render)
    },

    render() {
        this.destroySubviews()

        this.$el.html(
            this.template({
                conversations: {
                    loading: this.collection.isFetching(),
                    total: this.counter.get('count'),
                },
                link: {
                    allMessages: Router.path('spa_inbox_index_get', null, {
                        query: { ref: 'he_msg' },
                    }),
                },
            })
        )

        this.initSubview(
            ConversationListView,
            {
                el: this.$('.js-conversations-list'),
                collection: this.collection,
            },
            { remove: 'content' }
        ).render()

        if (this.counter.get('count')) {
            this.initSubview(
                CounterBadgeView,
                {
                    el: this.$('.js-count-header'),
                    model: this.counter,
                },
                { remove: 'content' }
            ).render()

            this.initSubview(
                CounterView,
                {
                    el: this.$('.js-count-results'),
                    model: this.counter,
                },
                { remove: 'content' }
            ).render()
        }

        return this
    },
})

export default ConversationsView
